import React from "react";
import Image from "../assets/IAM-Advisory-4.png";
import { Card, Col, Container, ListGroup, Row } from "react-bootstrap";
import { FaQuoteLeft } from "react-icons/fa";
import { FaQuoteRight } from "react-icons/fa";
import { SiTicktick } from "react-icons/si";
import BG from "../assets/Blue.png";
import Footer from "../components/Footer";
import '../utils/effectCSS/Effects.css';

const PrivilegeAcessManagement = () => {
  return (
    <>
      <Container
        fluid
        className="py-5"
        style={{
          backgroundImage: "url(" + BG + ")",
        }}
      >
        <div
          style={{
            height: "70px",
          }}
        ></div>
        <h2 className="text-center p-4">
          <b>Privilege Access Management</b>
        </h2>

        <hr
          className="d-flex justify-content-center"
          style={{
            width: "10%",
            border: "1.5px solid blue",
            margin: "0 auto",
          }}
        />

        <div className="mt-5">
          <Row>
            <Col lg={2} className="d-flex justify-content-end">
              <FaQuoteLeft
                style={{
                  color: "#00FFFF",
                  fontSize: "25px",
                }}
              />
            </Col>

            <Col lg={8}>
              <Container fluid className="text-center">
                <p
                  style={{
                    fontSize: "1.25rem",
                  }}
                >
                  Unlock the full potential of Privileged Access Management (PAM) with our comprehensive solutions, you can trust that your sensitive access controls are in capable hands, giving you the freedom to focus on your strategic goals and operations without worrying about security risks.
                </p>
              </Container>
            </Col>

            <Col
              lg={2}
              className="d-flex align-items-start justify-content-start"
            >
              <FaQuoteRight
                style={{
                  color: "#00FFFF",
                  fontSize: "25px",
                }}
              />
            </Col>
          </Row>
        </div>
        <Container>
          <Row className="mt-5 align-items-stretch">
            <Col className="d-flex" lg={6} xs={12}>
              <img className="img-fluid" src={Image} alt="IAM" />
            </Col>
            <Col className="d-flex" lg={6} xs={12}>
              <Container
                className="flex-fill"
                style={{
                  backgroundColor: "#6495ED",
                  color: "white",
                  padding: "4rem 2rem",
                }}
              >
                <h4 className="">Why IDM 360 Analytics for PAM Implementation?</h4>

                <div className="mt-2">
                  <ListGroup className="border-0 bg-transparent ">
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Enhanced Communication – Collaborate with key stakeholders
                      to ensure the selected PAM solution aligns with the
                      organization’s needs and goals. Establishing clear
                      communication channels is essential for a successful
                      rollout.
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Improved User Adoption – Offering continuous support and
                      resources enables users to better understand and adhere to
                      PAM policies and procedures.
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Adaptability And Integration - Choose a solution that can
                      easily adapt to changing needs and integrate with other
                      systems to enhance security measures.
                    </ListGroup.Item>
                  </ListGroup>
                </div>
              </Container>
            </Col>
          </Row>
        </Container>
        <Card className="bg-transparent border border-0 text-black p-5 text-center">
          <Card.Body>
            <h3 className="text-center mb-4">
              <b>
                Securing Privileged Access in the Era of Cloud and Ransomware.
              </b>
            </h3>
            <hr
              className="d-flex justify-content-center"
              style={{
                width: "10%",
                border: "1.5px solid blue",
                margin: "0 auto",
              }}
            />
            <Container >
              <Row xs={1} lg={3}>
                <Col lg={2}></Col>
                <Col lg={8} className="mt-4">
                  <p
                    style={{
                      fontSize: "1.25rem",
                    }}
                  >
                   IDM 360 Analytics offers advanced solutions that let companies set very specific rules about who can access certain information and under what circumstances that access can be taken away. This ensures businesses have full control over who sees their critical data and can act quickly if needed to protect it.
                  </p>
                  <p
                    className="mt-5"
                    style={{
                      fontSize: "1.25rem",
                    }}
                  >
                    When privilege access management and access governance are implemented correctly, they prevent breaches from both external attackers and internal threats. These solutions also include analytics and intelligence features that can identify system vulnerabilities, helping to protect the organization from potential risks.
                  </p>
                </Col>
                <Col lg={2}></Col>
              </Row>
            </Container>
          </Card.Body>
        </Card>

        <Container className="p-0">
          {/* First Row */}
          <Row className="justify-content-center g-3 align-items-stretch">
            <Col lg={4} className="d-flex hover-left">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#3457D5",
                  color: "white",
                }}
              >
                <h5>Strategic Consulting</h5>
              </Container>
            </Col>

            <Col lg={6} className="d-flex hover-right">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                  Our experienced consultants work closely with your team to assess your current security posture, identify gaps, and develop tailored strategies to enhance security, streamline operations, and drive business success. We provide actionable insights that align with your organization's objectives.
                </p>
              </Container>
            </Col>
          </Row>
          {/* Second Row */}
          <Row className="justify-content-center g-3 mt-1 align-items-stretch">
            <Col lg={6} className="d-flex order-2 order-lg-1 hover-left">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                  In today’s digital world, privileged access is both a powerful tool and a potential security risk—it can grant access to critical systems but also expose them to threats. IDM 360 Analytics's complete PAM implementation services help you apply the principle of least privilege, giving you full control and ensuring the highest level of security.                </p>
              </Container>
            </Col>

            <Col lg={4} className="d-flex order-1 order-lg-2 hover-right">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#1ca9c9",
                  color: "white",
                }}
              >
                <h5>PAM Implementation</h5>
              </Container>
            </Col>
          </Row>
          {/* Third Row */}
          <Row className="justify-content-center g-3 mt-1 align-items-stretch">
            <Col lg={4} className="d-flex hover-left">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#3457D5",
                  color: "white",
                }}
              >
                <h5>Onboarding PAM Experts</h5>
              </Container>
            </Col>

            <Col lg={6} className="d-flex hover-right">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                 At IDM 360 Analytics, we assist in onboarding Privilege Access Management (PAM) experts who bring specialized knowledge and experience to secure your organization’s critical assets. Our team works closely with your internal staff, providing training, guidance, and support to ensure effective implementation.                 </p>
              </Container>
            </Col>
          </Row>
          {/* Forth Row */}
          <Row className="justify-content-center g-3 mt-1 align-items-stretch">
            <Col lg={6} className="d-flex order-2 order-lg-1 hover-left">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                  IDM 360 Analytics offers comprehensive Privilege Access Management (PAM) Program Management services, ensuring the smooth operation and continuous improvement of your PAM strategy. Our team oversees the entire program lifecycle, from implementation to ongoing optimization, aligning with your business objectives.
</p>
              </Container>
            </Col>

            <Col lg={4} className="d-flex order-1 order-lg-2 hover-right">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#1ca9c9",
                  color: "white",
                }}
              >
                <h5>PAM Program Management</h5>
              </Container>
            </Col>
          </Row>
        </Container>
      </Container>
      <div className="mt-4">
        <Footer />
      </div>
    </>
  );
};

export default PrivilegeAcessManagement;
